import React from 'react';
import { ICartItem } from '../../../interfaces';
import { useAppSelector } from '../../../data/store';
import { ProductDepartmentEnum } from '../../../../../products/enums/product-department-enum';
import { getWupDate } from '../../../domain/shopping-cart-provider';

interface ICartItemTitle {
    cartItem: ICartItem,
    classes?: string,
}

const CartItemTitle = (props: ICartItemTitle) => {
    const cartItem = props.cartItem;
    const isInAppPurchase = useAppSelector(store => store.root.isInAppPurchase);
    const showLink = !!cartItem.documentUrlPath && !isInAppPurchase;

    return (
        <div className={ props.classes }>
            {
                showLink &&
                <a
                    href={ cartItem.documentUrlPath }
                    title=""
                    data-qa="cart-step1-product-name"
                    className="text-gray-700 no-underline">{ cartItem.skuName }</a>
            }

            { !showLink && <span data-qa="cart-step1-product-name">{ cartItem.skuName }</span> }

            {
                cartItem.skuDepartmentID === ProductDepartmentEnum.WavesUpdatePlan && getWupDate(cartItem) &&
                (
                    <>
                        <span className="font-normal text-sm ml-4 mr-2">({ getWupDate(cartItem) })</span>
                        <a href="/account/get-waves-update-plan" title="" className="font-normal underline text-sm">Change</a>
                    </>
                )
            }
        </div>
    )
};

export default CartItemTitle;